// Shared network config for BOTH HTTP clients — the axios client
// (services/api.ts) and the fetch client (services/api/client.ts). Keeping
// the request timeout here means the two clients can never drift apart into
// two independently-hardcoded literals; change it once, both clients pick it
// up.
//
// 30s matches the pre-existing axios `timeout: 30000` (services/api.ts) that
// this constant now replaces at its call site.
export const REQUEST_TIMEOUT_MS = 30_000
